// auth.service.ts
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from "@angular/common/http";
import { environment } from "src/envs/environnement";
import { Observable, tap } from "rxjs";
import { jwtDecode } from "jwt-decode";

export interface OtpChallengeResponse {
    requiresOtp: boolean;
    tempToken: string;
    emailMasque: string;
}

export interface JwtResponse {
    token: string;
    user: any;
    preferences?: any;
}

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    public isAuthenticatedUser: boolean = false;
    private tokenKey = 'token';
    private baseUrl = environment.baseUrl;
    constructor(private router: Router, private http: HttpClient) { }

    // Méthode pour se connecter
    login(data: any): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}/users/authenticate`, data);
    }

    /** Etape 1 du flux OTP : vérifie les identifiants et déclenche l'envoi du code. */
    authenticate(username: string, motDePasse: string): Observable<OtpChallengeResponse> {
        return this.http.post<OtpChallengeResponse>(`${this.baseUrl}/users/authenticate`, { username, motDePasse });
    }

    /** Etape 2 du flux OTP : vérifie le code et retourne le JWT définitif. */
    verifyOtp(tempToken: string, code: string): Observable<JwtResponse> {
        return this.http.post<JwtResponse>(`${this.baseUrl}/users/verify-otp`, { tempToken, code });
    }

    register(data: any): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}/users/register`, data);
    }

    // Inscription libre-service : cree le compte ET sa structure en un seul
    // appel (voir UserController#inscription cote backend), renvoie
    // directement un JWT exploitable comme /authenticate.
    inscription(data: any): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}/users/inscription`, data);
    }


    /**
     * Renouvelle le JWT sans déconnexion.
     * À appeler après toute modification du profil ou d'un rôle/permission
     * pour que les nouvelles permissions soient prises en compte immédiatement.
     */
    refreshToken(): Observable<JwtResponse> {
        return this.http.post<JwtResponse>(`${this.baseUrl}/users/refresh-permissions`, {}).pipe(
            tap((response: JwtResponse) => {
                sessionStorage.setItem('token', response.token);
            })
        );
    }

    // Méthode pour se déconnecter
    logout(): void {
        this.isAuthenticatedUser = false;
        this.router.navigateByUrl("");
    }

    // Vérifier si l'utilisateur est connecté
    isLoggedIn(): boolean {
        const token = sessionStorage.getItem("token");
        if (!token) return false;

        try {
            const decodedToken: any = jwtDecode(token);
            const currentTime = Math.floor(Date.now() / 1000); // Convertir en secondes

            return decodedToken.exp > currentTime; // ✅ Vérifier si le token est expiré
        } catch (error) {
            console.error("Erreur lors du décodage du token :", error);
            return false; // Si le token est invalide, l'utilisateur n'est pas connecté
        }
    }





    loginUser(data: any): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}/users/authentification`, data);

    }


    createUser(data: any): Observable<any> {

        return this.http.post<any>(`${this.baseUrl}/users/create`, data);

    }






    getRoles(): string[] {
        const token = sessionStorage.getItem('token');
        if (!token) return [];

        try {
            // Define the expected structure of the decoded token
            const decodedToken: { roles?: string[] } = jwtDecode(token);
            return decodedToken.roles || [];
        } catch (error) {
            console.error('Error decoding token:', error);
            return [];
        }
    }


    isAuthenticated(): boolean {
        const token = sessionStorage.getItem("token");
        if (!token) return false;

        const decodedToken: any = jwtDecode(token);
        const currentTime = Math.floor(Date.now() / 1000);

        // Vérifiez si le token est expiré
        return decodedToken.exp > currentTime;
    }

    hasRole(roles: Array<string>): boolean {
        const token = sessionStorage.getItem(this.tokenKey);
        if (!token) return false;

        const decodedToken: any = jwtDecode(token);
        const userRoles: Array<string> = decodedToken.roles || [];

        // Vérifiez si l'utilisateur a au moins un des rôles requis
        return roles.some(role => userRoles.includes(role));
    }


    getUser(): any {
        const token = sessionStorage.getItem(this.tokenKey);
        if (!token) return null;
        try {
            return jwtDecode(token);
        } catch (error) {
            console.error('Error decoding token', error);
            return null;
        }
    }
}
